import React from 'react';

// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

type ComponentProps = IconType & {
  fillIconPaused?: string;
  fillLine?: string;
}

const IconCrossPaused: React.FC<ComponentProps> = ({
  size,
  inverse,
  onClick,
  width,
  height,
  iconClassName,
  fillIconPaused = '#787878',
  fillLine = '#000000',
}) => {

  const defaultMeasurements: Measurements = {
    height: 15,
    width: 22,
  }

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-cross-paused">
      <svg
        className="fill-current"
        width={width || measurements.width}
        height={height || measurements.height}
        viewBox="0 0 22 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5.15848 14C5.15848 14.5523 5.60619 15 6.15848 15H8.15848C8.71076 15 9.15848 14.5523 9.15848 14V1C9.15848 0.447715 8.71076 0 8.15848 0H6.15848C5.60619 0 5.15848 0.447715 5.15848 1V14ZM14.1585 0C13.6062 0 13.1585 0.447715 13.1585 1V14C13.1585 14.5523 13.6062 15 14.1585 15H16.1585C16.7108 15 17.1585 14.5523 17.1585 14V1C17.1585 0.447715 16.7108 0 16.1585 0H14.1585Z" fill={fillIconPaused} />
        <rect x="20" width="1.89421" height="23.3541" transform="rotate(54.8314 20 0)" fill={fillLine} />
      </svg>
    </Icon>
  );
};

export default IconCrossPaused;
